<template>
  <div class="contact1">
    <div class="container-contact1">
      <div
        class="contact1-pic js-tilt"
        data-tilt
        style="will-change: transform; transform: perspective(300px) rotateX(0deg) rotateY(0deg);"
      >
        <img :src="require('@/assets/contact/img-01.png')" alt="IMG" />
      </div>
      <form class="contact1-form validate-form" @submit.prevent="sendContactMessage()">
        <h3>
          <font color="darkblue">&nbsp;Envie-nos sua mensagem</font>
        </h3>
        <br />

        <div class="wrap-input1 validate-input" data-validate="Forneça um nome">
          <input
            class="input1"
            type="text"
            name="name"
            v-model="contact.name"
            placeholder="Nome"
            required
          />
          <span class="shadow-input1"></span>
        </div>
        <div class="wrap-input1 validate-input" data-validate="E-mail inválido. Digite novamente">
          <input
            class="input1"
            type="text"
            name="email"
            v-model="contact.email"
            placeholder="E-mail"
            required
          />
          <span class="shadow-input1"></span>
        </div>
        <div class="wrap-input1 validate-input" data-validate="Informe o assunto">
          <input
            class="input1"
            type="text"
            name="subject"
            v-model="contact.subject"
            placeholder="Assunto"
            required
          />
          <span class="shadow-input1"></span>
        </div>
        <div class="wrap-input1 validate-input" data-validate="Digite uma mensagem">
          <textarea
            class="input1"
            name="message"
            v-model="contact.message"
            placeholder="Mensagem"
            required
          ></textarea>
          <span class="shadow-input1"></span>
        </div>
        <div class="container-contact1-form-btn">
          <button type="submit" class="contact1-form-btn" :disabled="loading">
            <span v-if="!loading">
              ENVIAR
              <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
            </span>

            <span v-if="loading">ENVIANDO...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import "@/assets/contact/bootstrap.min.css";
import "@/assets/contact/main.css";
// import '@/assets/contact/main';

import { sendContactMessage } from "@/services/utils";

export default {
  methods: {
    sendContactMessage() {
      this.$data.loading = true;
      sendContactMessage({ ...this.$data.contact })
        .then((resp) => {
          alert("Mensagem enviada com sucesso");
          this.$data.loading = false;
          this.$data.contact = {
            name: null,
            email: null,
            subject: null,
            message: null,
          };
        })
        .catch((err) => {
          console.log(err);
          alert("Houve um erro ao enviar e-mail");
          this.$data.loading = false;
        });
    },
  },

  data() {
    return {
      loading: false,
      contact: {
        name: null,
        email: null,
        subject: null,
        message: null,
      },
    };
  },
};
</script>

<style>
main {
  background-color: #eee !important;
}

.contact1-form-btn[disabled] {
  cursor: not-allowed;
  background-color: #333;
}
</style>